module.exports = __webpack_public_path__ + "img/solution1_painPoint.43b442e0.png";